<div class="card">
  <div class="card-body mb-2">

    <div class="row">
      <div class="col-md-12">
        <h4 *ngIf="userCourseType !== 'contractor'">Section {{ sectionData.sectionOrder }} - Training Document</h4>
        <h4 *ngIf="userCourseType === 'contractor'">Section {{ sectionData.sectionOrder }} - Outage Acceptance Document</h4>
        <p><b>Please read the following information before proceeding</b></p>
        <pdf-viewer [src]="sectionData.documentUrl" (onPdfEnd)="canProceed = true"></pdf-viewer>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <a [routerLink]="backLink" [queryParams]="{type: userCourseType}" class="secondary-link-btn">course overview</a>
        <button type="button" *ngIf="!isComplete" [disabled]="!canProceed" class="my-2 btn btn-round btn-sm btn-success float-right" (click)="submit()">Next</button>
        <button type="button" *ngIf="isComplete" class="my-2 btn btn-round btn-sm btn-primary float-right" (click)="onGoToNextSection.emit()">Next</button>
      </div>
    </div>
  </div>
</div>
